import { BoxProps } from '@chakra-ui/react';
import React from 'react';

import { CmBox, CmText } from '@/components/uiParts';

interface Props extends BoxProps {
  icon: React.ReactNode;
}

export const TextIcon: React.FC<Props> = ({ icon, children, ...rest }) => {
  return (
    <CmBox display="flex" alignItems="center" {...rest}>
      {icon}
      <CmText ml={2}>{children}</CmText>
    </CmBox>
  );
};
